/* @flow */
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import React from 'react';

import _ from 'lodash';
import cx from 'classnames';

import './styles/Coin.scss';

const COLORS = [
  'lava',
  'flame',
  'sunrise',
  'shamrock',
  'jungle',
  'brand',
  'violet',
  'thunder',
  'midnight',
  'eclipse',
  'koala',
  'pitch',
  'white',
  'facebook',
  'pinterest',
  'twitter',
];

/**
 * A component that renders a circle containing centered content.
 *
 *
 * ```example
 *  <div>
 *    <Coin color="brand" size="xxxlarge">
 *      <Text color="white">
 *        <Glyph name="check" />
 *      </Text>
 *    </Coin>
 *    <Coin color="lava" size="xlarge">
 *      <Text color="white">
 *        <Glyph name="check" />
 *      </Text>
 *    </Coin>
 *    <Coin border="jungle" size="medium">
 *      <Text color="jungle">
 *        <Glyph name="check" />
 *      </Text>
 *    </Coin>
 *    <Coin border="lava" size="xxxsmall">
 *      <Text color="lava">
 *        <Glyph name="check" />
 *      </Text>
 *    </Coin>
 *  </div>
 * ```
 */

class Coin extends React.Component {
  static propTypes = {
    // these are used by getPropClasses
    color: React.PropTypes.oneOf(COLORS), // eslint-disable-line
    border: React.PropTypes.oneOf(COLORS), // eslint-disable-line
    size: React.PropTypes.oneOf([ // eslint-disable-line
      'inherit',
      'xxxsmall',
      'xxsmall',
      'xsmall',
      'small',
      'medium',
      'large',
      'xlarge',
      'xxlarge',
      'xxxlarge',
    ]),
  };

  static propClasses = {
    color: _.zipObject(COLORS, _.map(COLORS, color => `Coin-color-${color}`)),
    border: _.zipObject(COLORS, _.map(COLORS, color => `Coin-border-${color}`)),
    size: {
      xxxsmall: 'Coin-sizeXxxSmall',
      xxsmall: 'Coin-sizeXxSmall',
      xsmall: 'Coin-sizeXSmall',
      small: 'Coin-sizeSmall',
      medium: 'Coin-sizeMedium',
      large: 'Coin-sizeLarge',
      xlarge: 'Coin-sizeXLarge',
      xxlarge: 'Coin-sizeXxLarge',
      xxxlarge: 'Coin-sizeXxxLarge',
    },
  };

  render() {
    return (
      <span className={cx('Coin', getPropClassesFromInstance(this), this.props.className)}>
        <span className="Coin-content">
          {this.props.children}
        </span>
      </span>
    );
  }
}

export default Coin;



// WEBPACK FOOTER //
// ./src/components/Coin.jsx